export default "__VITE_ASSET__CojNshLc__";